import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services

import Bannerapi from "Services/Bannermanage";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BannerUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

   // Dropzone for Bannerimage props
   const { getRootProps:rootforBannerImage ,
    getInputProps:inputforBannerImage , 
    open:openforBannerImage } = useDropzone({
noClick: true,
noKeyboard: true,
maxSize: formatBytes(maxFileSize),
maxFiles: 1,
accept: "image/*",
validator: fileLengthValidator,
onDrop: (acceptedFiles) => {
let fileLength = acceptedFiles.map((file) => file.size);
if (acceptedFiles && fileLength < maxFileSize) {
  const file = acceptedFiles[0];

  // Convert file to Base64
  const reader = new FileReader();
  reader.onload = () => {
    const base64String = reader.result;
    formik.setFieldValue("BannerImagefile", file);
    formik.setFieldValue("BannerImage", base64String); // Keep the file for form submission
  };
  reader.onerror = (error) => {
    console.error("Error converting file to Base64:", error);
  };
  reader.readAsDataURL(file); // Convert file to Base64
}
},
});

// Dropzone for descriptionimage props
const {getRootProps:rootfordescimage ,
getInputProps:inputfordescimage , 
open:openfordescimage } = useDropzone({
noClick: true,
noKeyboard: true,
maxSize: formatBytes(maxFileSize),
maxFiles: 1,
accept: "image/*",
validator: fileLengthValidator,
onDrop: (acceptedFiles) => {
let fileLength = acceptedFiles.map((file) => file.size);
if (acceptedFiles && fileLength < maxFileSize) {
const file = acceptedFiles[0];

// Convert file to Base64
const reader = new FileReader();
reader.onload = () => {
  const base64String = reader.result;
  formik.setFieldValue("descriptionImagefile", file);
  formik.setFieldValue("descriptionImage", base64String); // Keep the file for form submissio
};
reader.onerror = (error) => {
  console.error("Error converting file to Base64:", error);
};
reader.readAsDataURL(file); // Convert file to Base64
}
},
});
  // Fetch Passenger Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        //console.log("fetched data--->",res.data);
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    Bannerapi.getBannerbyid(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateBanner = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;
       //console.log('formValues?.BannerImage-->',formValues?.BannerImage);
    const data = {
      BannerName: formValues?.BannerName,
      BannerImage: formValues?.BannerImagefile,
    
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Banner Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update Banner details api error", err);
    };

    if (validatationPass) {
      Bannerapi.updateBanner(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
      if (!_.isEmpty(details)) {
        formik.setFieldValue("BannerName", details?.BannerName);
        formik.setFieldValue("BannerImage", details?.BannerImage);
        formik.setFieldValue("BannerImagefile", details?.BannerImage);
     
      }
      //console.log('formik--->',formik);
    };
    updateFormValues();
  }, [details]);

  // Formik

  const formik = useFormik({
    initialValues: {
      BannerImage:"",
      BannerImagefile:"",
      BannerName: "",
   
    },
    validationSchema: yup.object({
      BannerName: yup.string().required("Banner Name is required").nullable(),
      
      BannerImage: yup.string().required("Banner Image is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateBanner,
  });

  //Tabs

  return (
    <>
<Dialog
open={openDialog}
TransitionComponent={Transition}
keepMounted
onClose={handleClose}
maxWidth={"xl"}
aria-describedby="dialog-box"
className={classes.root}
>
<DialogTitle>
  <section className={classes.dialogTitleContainer}>
    <Typography variant="body1" className={classes.title}>
      Update Banner
    </Typography>
    <IconButton aria-label="close" onClick={handleClose}>
      <CloseIcon className={classes.closeIcon} />
    </IconButton>
  </section>
</DialogTitle>
<DialogContent>

<Grid container spacing={2} rowSpacing={3} columnSpacing={4} className={classes.detailsContainer} >

{/* Banner details feilds */}





<Grid item xs={12}  >

<h5>Banner </h5>

<img src={formik?.values?.BannerImage?
  formik?.values?.BannerImage:"/assets/images/logos/no-image.png"
}
alt="avatar"
className={classes.carimages}
/>

<section {...rootforBannerImage()} onClick={openforBannerImage} >
<input {...inputforBannerImage()} />
<CameraAltOutlinedIcon />
</section>

{formik.errors.BannerImage && formik.touched.BannerImage && (
<Typography color="error" variant="caption">
{formik.errors.BannerImage}
</Typography>
)}

</Grid>



<Grid item xs={12} >
<TextField
name="BannerName"
id="BannerName"
label="banner Name"
value={formik?.values?.BannerName}
defaultValue={formik?.values?.BannerName}
onChange={formik.handleChange}
error={
formik?.errors?.BannerName &&
formik?.touched?.BannerName
}
helperText={
formik?.errors?.BannerName &&
formik?.touched?.BannerName &&
formik?.errors?.BannerName
}
fullWidth
variant="outlined"
size="small"
multiline
rows={4}
></TextField>
</Grid>



{/* Add Banner button */}      
<Grid item xs={12}>
<Button variant="contained" onClick={formik?.handleSubmit} className={classes.sbtBtnWrapper}>
Update Banner
</Button>
</Grid>

</Grid>

</DialogContent>
<Divider />
<DialogActions>
  <section className={classes.dialogActions}>
    <section className={classes.closeBtn}>
      <Button onClick={handleClose}>Close</Button>
    </section>
  </section>
</DialogActions>
</Dialog>
    </>
  );
};

export default BannerUpdate;
